import { EventVm } from '../utils/api';

import { compareEventPosition } from './eventPosition';

export { compareEventPosition } from './eventPosition';

export const shootoutRows = (events: EventVm[]): EventVm[] =>
    events.filter(e => e.shootoutOrder != null).sort(compareEventPosition);

export const moveShootoutRow = (ids: number[], id: number, direction: -1 | 1): number[] => {
    const result = [...ids];
    const from = result.indexOf(id);
    const to = from + direction;
    if (from >= 0 && to >= 0 && to < result.length) [result[from], result[to]] = [result[to], result[from]];
    return result;
};
